import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  deleteAdmin,
  inviteAdmin,
  sendAdminPasswordReset,
  updateAdmin,
} from '../../../api/admins';
import type { AdminInvitePayload, AdminUpdatePayload } from '../../../types/admins';
import { useAuth } from '../../auth/AuthProvider';

export function useInviteAdmin() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AdminInvitePayload) => inviteAdmin(payload, tokens!.access_token),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admins'] }),
  });
}

export function useUpdateAdmin() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, payload }: { userId: string; payload: AdminUpdatePayload }) =>
      updateAdmin(userId, payload, tokens!.access_token),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admins'] });
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
}

export function useDeleteAdmin() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => deleteAdmin(userId, tokens!.access_token),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admins'] }),
  });
}

export function useSendAdminPasswordReset() {
  const { tokens } = useAuth();

  return useMutation({
    mutationFn: (userId: string) => sendAdminPasswordReset(userId, tokens!.access_token),
  });
}
